export default __webpack_public_path__ + "static/media/expImgBlack.6f43b1ca.svg";